export enum ActionTypes {
  SET_MENU = 'set_menu',
  SET_INSTRUCTIONS = 'set_instructions',
  PUSH_SCORE = 'push_score',
  RESET_SCORES = 'reset_scores',
}